import React, { useState } from 'react';
import { Users, GitBranch, CreditCard, Building2, User } from 'lucide-react';
import TeamsManagement from '../teams/TeamsManagement';
import LeadDistributionSettings from './LeadDistributionSettings';
import SubscriptionWrapper from './SubscriptionWrapper';
import OrganizationSettings from './OrganizationSettings';
import UserProfileSettings from './UserProfileSettings';
import Header from '../../components/header';
import '../../styles/designSystem.css';
import './settingsPage.scss';

type SettingsTab = 'teams' | 'distribution' | 'subscription' | 'organization' | 'profile';

const SettingsPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<SettingsTab>('teams');

  const tabs = [
    {
      id: 'organization' as SettingsTab,
      label: 'Organization',
      icon: Building2,
      description: 'Organization settings'
    },
    {
      id: 'profile' as SettingsTab,
      label: 'User Profile',
      icon: User,
      description: 'Personal information'
    },
    {
      id: 'teams' as SettingsTab,
      label: 'Teams',
      icon: Users,
      description: 'Manage team members and roles'
    },
    {
      id: 'distribution' as SettingsTab,
      label: 'Lead Distribution',
      icon: GitBranch,
      description: 'Configure distribution rules'
    },
    {
      id: 'subscription' as SettingsTab,
      label: 'Subscription',
      icon: CreditCard,
      description: 'Plans and billing'
    }
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'organization':
        return <OrganizationSettings />;
      case 'profile':
        return <UserProfileSettings />;
      case 'teams':
        return <TeamsManagement />;
      case 'distribution':
        return <LeadDistributionSettings />;
      case 'subscription':
        return <SubscriptionWrapper />;
      default:
        return <TeamsManagement />;
    }
  };

  return (
    <>
      <Header />
      <div className="settings-page-container">
        {/* Settings Sidebar Navigation */}
        <aside className="settings-sidebar-nav">
          <div className="settings-sidebar-header">
            <div className="ds-flex ds-items-center ds-gap-3">
              <h2 className="ds-h3" style={{ margin: 0 }}>Settings</h2>
           
            </div>
            <p className="ds-body-sm ds-text-secondary" style={{ margin: '0.5rem 0 0 0' }}>
              Customize 3Sigma settings
            </p>
          </div>

          <nav className="settings-nav-list">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  className={`settings-nav-item ${activeTab === tab.id ? 'active' : ''}`}
                  onClick={() => setActiveTab(tab.id)}
                >
                  <div className="settings-nav-item-icon">
                    <Icon size={20} />
                  </div>
                  <div className="settings-nav-item-content">
                    <div className="settings-nav-item-label">{tab.label}</div>
                    <div className="settings-nav-item-description">{tab.description}</div>
                  </div>
                </button>
              );
            })}
          </nav>
        </aside>

        {/* Settings Content */}
        <main className="settings-main-content">
          {renderContent()}
        </main>
      </div>
    </>
  );
};

export default SettingsPage;